import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { RHeader, RPage, RViewer } from '../../../../components/PdfRender';
import { useCompany } from '../../../../hooks/company';
import { IClient } from '../../../interfaces';
import * as S from './styles';
import { formatDate } from '../../../utils/format-date';

interface IClientReportBirthdaysProps {
  clients: IClient[];
}

export const ClientReportBirthdays: React.FC<IClientReportBirthdaysProps> = ({
  clients,
}) => {
  const { company } = useCompany();

  return (
    <RViewer>
      <RPage size={'A4'}>
        <View style={S.styles.container}>
          <RHeader company={company} />
          <Text style={S.styles.title}>Relatório de Aniversariantes</Text>

          <View style={S.styles.table}>
            <View style={[S.styles.tableRow, S.styles.tableHeader]}>
              <View style={[S.styles.tableCol, S.styles.colDate]}>
                <Text style={S.styles.headerText}>Data</Text>
              </View>
              <View style={[S.styles.tableCol, S.styles.colName]}>
                <Text style={S.styles.headerText}>Nome</Text>
              </View>
              <View style={[S.styles.tableCol, S.styles.colPhone]}>
                <Text style={S.styles.headerText}>Telefone</Text>
              </View>
            </View>

            {clients.map((item, index) => (
              <View key={index} style={S.styles.tableRow}>
                <View style={[S.styles.tableCol, S.styles.colDate]}>
                  <Text style={S.styles.text}>{formatDate(item.birthday)}</Text>
                </View>
                <View style={[S.styles.tableCol, S.styles.colName]}>
                  <Text style={S.styles.text}>{item.corporate_name}</Text>
                </View>
                <View style={[S.styles.tableCol, S.styles.colPhone]}>
                  <Text style={S.styles.text}>{item.cell_phone || '-'}</Text>
                </View>
              </View>
            ))}
          </View>
        </View>
      </RPage>
    </RViewer>
  );
};
